import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { UserTable } from '../../../../tables/user-table'

const Groups = observer(() => {
  const match = useRouteMatch<any>('/content/quizzes/:id/groups')
  const quizID = Number(match?.params?.id)

  const [tableHelper] = useState(new TableHelper('list_quiz_groups', 'groups', 'quizzes', quizID))

  return <UserTable tableHelper={tableHelper} />
})

export const QuizzesGroupsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Groups',
    path: `/content/quizzes/${id}/groups`,
    component: () => <Groups />,
  }
}
